import { render, staticRenderFns } from "./PricingJewellersTourPrimaryLayer.vue?vue&type=template&id=b72953a8"
import script from "./PricingJewellersTourPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingJewellersTourPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports